import React from "react"
import Layout from "../../components/layout/Layout";
import UserProfileContent from "../../components/userprofile/UserProfileContent";
import { useParams } from "react-router";

const UserProfile = () => {
  const { userId } = useParams<Record<string, string>>();
  return (
    <div>
      <Layout>
        {userId && <UserProfileContent userId={userId} />}
      </Layout>
    </div>
  )
}

export default UserProfile;